import { Link } from "react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Shield, ChevronRight } from "lucide-react";

export function LegalSection() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-muted-foreground" />
          <CardTitle className="text-lg">Legal</CardTitle>
        </div>
        <CardDescription>Privacy and terms</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <Link to="/privacy">
          <Button
            variant="ghost"
            className="w-full justify-between text-muted-foreground hover:text-foreground"
          >
            <div className="flex items-center">
              <Shield className="h-4 w-4 mr-2" />
              Privacy Policy
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
        <Link to="/terms">
          <Button
            variant="ghost"
            className="w-full justify-between text-muted-foreground hover:text-foreground"
          >
            <div className="flex items-center">
              <FileText className="h-4 w-4 mr-2" />
              Terms of Service
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
